import { Icon, NavigationSlider } from '@yes.technology/react-toolkit'
import { useTranslation } from 'react-i18n-lite'
import { useFilterFieldsContext } from '../../context'
import {
  useSectionGroupActions,
  useSectionNavigation
} from '../Section/SectionContext'
import { GroupSideButtons, StyledFilterButton } from './GroupControls.styles'
import type { CommonControlsProps } from './CommonControls.types'

const CommonControls = ({ onRemoveClick }: CommonControlsProps) => {
  const { t } = useTranslation()

  const { groupPosition, groupsLength, setGroupPosition } =
    useSectionNavigation()

  const { handleClearCurrentGroup } = useSectionGroupActions()

  const { styling } = useFilterFieldsContext()
  const { navigationSliderBackgroundColor, navigationSliderColor } = styling

  return (
    <>
      <NavigationSlider
        ignoreHeight
        heightClass='small'
        className='py-2 py-lg-0'
        hierarchyLevel='level_4'
        currentPosition={groupPosition}
        first={1}
        total={groupsLength}
        afterClick={setGroupPosition}
        textForCurrent='Grupo'
        arrowOrientationButtons='diagonalArrows'
        backgroundColor={navigationSliderBackgroundColor}
        color={navigationSliderColor}
      />
      <GroupSideButtons className='pt-2 pt-lg-0'>
        <StyledFilterButton
          heightClass='regular'
          onClick={handleClearCurrentGroup}
          variant='secondary'
          aria-label={t('filter-fields.clean')}
          color={navigationSliderColor}
        >
          {t('filter-fields.clean')}
        </StyledFilterButton>
        {groupsLength > 1 && (
          <StyledFilterButton
            heightClass='regular'
            variant='secondary'
            onClick={onRemoveClick}
            aria-label={t('filter-fields.remove-group')}
            color={navigationSliderColor}
          >
            <Icon iconName='Cleaner' icSize='regular' />
          </StyledFilterButton>
        )}
      </GroupSideButtons>
    </>
  )
}

export default CommonControls
